import {
  instance,
} from './index';

const addUser = async (user) => {
  const res = await instance.post('/users', user);
  return res;
};
const getUsers = async (masterUser) => {
  const res = await instance.get(`/users/all/${masterUser}`);
  return res;
};
const getUser = async (userId) => {
  const res = await instance.get(`/users/${userId}`);
  return res;
};
const updateUser = async (userId, user) => {
  const res = await instance.put(`/users/${userId}`, user);
  return res;
};
export {
  addUser,
  getUsers,
  getUser,
  updateUser,
};
